import { render } from "./CompanyCulture.vue?vue&type=template&id=1511ef51&scoped=true&ts=true"
import script from "./CompanyCulture.vue?vue&type=script&lang=ts"
export * from "./CompanyCulture.vue?vue&type=script&lang=ts"

import "./CompanyCulture.vue?vue&type=style&index=0&id=1511ef51&scoped=true&lang=scss"

import exportComponent from "/Users/daiwei/Documents/Dodoca/guinong/guinong-official-website/website/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1511ef51"]])

export default __exports__